export const STATUSCHANGED = "todos/statusChanged";
export const COLORCHANGED = "todos/colorChanged";
